/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Top-level menu items with a dropdown (e.g. "Naiset", "Miehet") should
  // just open their submenu on click, not navigate away.
  document.addEventListener('click', function (event) {
    var topLink = event.target.closest('[data-top-link]');
    if (topLink) {
      var hasDropdown = topLink.closest('[aria-haspopup="true"]');
      if (hasDropdown) {
        event.preventDefault();
        return;
      }
    }

    // Mega-menu column headers (e.g. "Mekot", "Setit", "Vaatteet", "Kengät",
    // "Asusteet", "Takit") are just group labels, not real links either.
    var familyHeader = event.target.closest('[data-stagger-first]');
    if (familyHeader) {
      event.preventDefault();
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
